// https://cloud.tencent.com/document/product/1110/36841
class TencentCaptchaClass {
  constructor(captchaAppid) {
    this.captchaAppid = captchaAppid;
  }
  // 定义回调函数
  captchaCallback(opt) {
    const res = opt.res;
    const resolve = opt.resolve;
    // 第一个参数传入回调结果，结果如下：
    // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
    // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
    // CaptchaAppId       String    验证码应用ID。
    // bizState    Any       自定义透传参数。
    // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。

    // res（用户主动关闭验证码）= {ret: 2, ticket: null}
    // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    // res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
    // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
    resolve(res);
  }

  // 定义验证码js加载错误处理函数
  loadErrorCallback(resolve) {
    // 生成容灾票据或自行做其它处理
    var ticket =
      "trerror_1001_" +
      this.captchaAppid +
      "_" +
      Math.floor(new Date().getTime() / 1000);
    this.captchaCallback({
      res: {
        ret: 0,
        randstr: "@" + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: "jsload_error",
      },
      resolve,
    });
  }

  captchaShow() {
    return new Promise((resolve, reject) => {
      try {
        // TODO
        // 如果没有开启直接 resolve
        if (!this.captchaAppid) {
          resolve();
        }
        // 生成一个验证码对象
        // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
        // callback：定义的回调函数
        // eslint-disable-next-line
        var captcha = new TencentCaptcha(
          this.captchaAppid,
          (res) =>
            this.captchaCallback({
              res,
              resolve,
            }),
          {}
        );
        // 调用方法，显示验证码
        captcha.show();
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        this.loadErrorCallback(reject);
      }
    });
  }
}
// https://doc.chuanglan.com/document/NYB7H00BI8ZSWS1I#NKNAGLYGGDWCJEEJVJ
class ChuangLanCaptchaClass {
  constructor(captchaAppid) {
    this.captchaAppid = captchaAppid;
  }
  // 定义回调函数
  captchaCallback(opt) {
    const res = opt.res;
    const resolve = opt.resolve;
    // 第一个参数传入回调结果，结果如下：
    // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
    // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
    // CaptchaAppId       String    验证码应用ID。
    // bizState    Any       自定义透传参数。
    // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。

    // res（用户主动关闭验证码）= {ret: 2, ticket: null}
    // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    // res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
    // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
    resolve(res);
  }

  // 定义验证码js加载错误处理函数
  loadErrorCallback(resolve) {
    // 生成容灾票据或自行做其它处理
    var ticket =
      "trerror_1001_" +
      this.captchaAppid +
      "_" +
      Math.floor(new Date().getTime() / 1000);
    this.captchaCallback({
      res: {
        ret: 0,
        randstr: "@" + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: "jsload_error",
      },
      resolve,
    });
  }

  captchaShow() {
    return new Promise((resolve, reject) => {
      try {
        // TODO
        // 如果没有开启直接 resolve
        if (!this.captchaAppid) {
          resolve();
        }
        // 生成一个验证码对象
        // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
        // callback：定义的回调函数
        // eslint-disable-next-line
        var captcha = new TencentCaptcha(
          this.captchaAppid,
          (res) =>
            this.captchaCallback({
              res,
              resolve,
            }),
          {}
        );
        // 调用方法，显示验证码
        captcha.show();
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        this.loadErrorCallback(reject);
      }
    });
  }
}
class Captcha {
  constructor(captcha, mode) {
    if (mode === "tencent") {
      this.instance = new TencentCaptchaClass(captcha);
    }
    if (mode === "chuangLan") {
      this.instance = new ChuangLanCaptchaClass(captcha);
    }
  }
  captchaShow() {
    return this.instance.captchaShow();
  }
}

export function captchaShow(captchaAppid) {
  const instance = new Captcha(captchaAppid, "chuangLan");
  return instance.captchaShow();
}
